module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/bucks-ecbef67e17339af6291a49e805f5246e.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/bucks.svg
// module id = FlgI
// module chunks = 24